import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import className from 'classnames';
import { connect } from 'react-redux';
import { COMMENT_ACTIONS } from '../../constants/comment-actions';
import CommentAvatar from '../comment-avatar';
import { MoreButton } from '../more-button';
import CommentActions from '../../containers/comment-actions';
import TimeAgo from '../time-ago';
import withNavigation from '../../hoc/with-navigation';
import withPermissions from '../../hoc/with-permissions';
import { getCommentActions } from '../../services/comment-actions';
import { clickProfileLink } from '../../actions/click-profile-link';
import { isOneAppSearchParam } from '@wix/communities-blog-client-common';
import styles from './comment-header.scss';

const renderMoreButton = (comment, visibleActions) => {
  return (
    <div className={styles.moreButton}>
      <MoreButton>
        <CommentActions comment={comment} visibleActions={visibleActions} />
      </MoreButton>
    </div>
  );
};

const CommentHeader = ({
  comment,
  navigation: { ProfileLink },
  showMoreButton,
  type,
  visibleActions,
  clickProfileLink,
}) => (
  <div
    className={className(
      styles.commentHeader,
      styles[type],
      { [styles.withMoreButton]: showMoreButton },
      'comment-header',
    )}
  >
    <object type="communities/link" className={styles.commentAvatar}>
      <ProfileLink onClickExtension={() => clickProfileLink({ comment, post: comment.post })} user={comment.owner}>
        <CommentAvatar user={comment.owner} type={type} />
      </ProfileLink>
    </object>
    <span className={styles.commentTime}>
      <TimeAgo time={comment.createdDate} />
    </span>
    {showMoreButton && renderMoreButton(comment, visibleActions)}
  </div>
);

CommentHeader.SEARCH = 'search';

CommentHeader.propTypes = {
  comment: PropTypes.object.isRequired,
  navigation: PropTypes.object,
  showMoreButton: PropTypes.bool,
  type: PropTypes.string,
  visibleActions: PropTypes.arrayOf(PropTypes.string),
  clickProfileLink: PropTypes.func.isRequired,
};

const mapStateToProps = (state, { comment, canSee, visibleActions }) => {
  const commentActions = getCommentActions({
    comment,
    canSee,
    visibleActions: visibleActions || COMMENT_ACTIONS,
    enableShare: !isOneAppSearchParam(state),
  });

  return {
    showMoreButton: Boolean(commentActions.length),
  };
};

const mapDispatchToProps = {
  clickProfileLink,
};

export default flowRight(withPermissions, connect(mapStateToProps, mapDispatchToProps), withNavigation)(CommentHeader);
